import type { Node, NodeProps } from "@xyflow/react";

import { useDipLabels } from "~/features/dataImportProjects/hooks/useDipLabels";
import type { DipStageHeaderNodeData } from "~/features/dataImportProjects/types";

export function DipStageHeaderNode({ data }: NodeProps<Node<DipStageHeaderNodeData>>) {
  const labels = useDipLabels();
  return (
    <div
      className="rounded-[var(--radius-sm)] border border-border-default bg-bg-subtle px-3 py-2 text-12-bold text-fg-2"
      style={{ width: data.width ?? 380 }}
    >
      {labels[`stage.${data.titleKey}`] ?? data.titleKey}
    </div>
  );
}
